export { useApplyTemplateRoleContact } from './useApplyTemplateRoleContact';
